define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/action/EmailController",
	"csi/xml",
	"csi/xml/Search"
], function(declare,Memory,EmailController,xml,Search) {

	return declare(EmailController, {

		getUsersStoreOptions: function() {
			// summary: pull all Suppliers and Contacts from Suppliers into the list of available email addresses
			var options = this.inherited(arguments);

			var search = new Search({Module:EmailController.USERS_STORES_MODULE, Operation:EmailController.USERS_STORES_OPERATION});
			search.setLimitPath(this.m_urlNode, xml.path(xml.ATTR_PARENT));
			search.setLimitPath(this.m_urlNode, xml.path(xml.ATTR_PARENT, "Contacts"));
			var q = search.getQuery();
			q.Attr("Email", xml.OP_NOT_EQUALS, "");

			options.request = search.getRequest();

			return options;
		},

		getAttachmentsStore: function() {
			// summary: returns the attachments' store
			return new Memory({
				idProperty: "$",
				nameProperty: "Name",
				labelProperty: "Name",
				data: [
				    {$: "centric:", Name: this._getAttachmentName()}
				]
			});
		},

		getInitialValues: function() {
			// summary: get initial values for Email form
			var initialValues = this.inherited(arguments);

			initialValues.attachments = ["centric:"];

			return initialValues;
		},

		toWriter: function() {
			// summary: set values to email message
			var call = this.inherited(arguments);

			call.setModuleOperation("Quality", "EmailContractualDocumentPackageZip");
			call.addParameter("URL", xml.ATTR_REF, this.m_urlNode);
			call.addParameter("AttachmentName", xml.ATTR_STRING, this._getAttachmentName());

			return call;
		},

		_getAttachmentName: function() {
			var node = this.getNode();
			return node.$Name+".zip";
		}
	});
});